import { FC, useMemo } from "react";
import DetailsSectionColumns from "../../../../../../../components/Details/components/Main/Grid/DetailsSectionColumns";
import {
  InspectionType,
  Inspection,
  GetEditInspectionOnFormResponseDocument,
  GetEditInspectionOnFormResponseQueryVariables,
} from "../../../../../../../graphql/__GENERATED__/types";
import {
  formatISODate,
  formatPhone,
} from "../../../../../../../utils/formatNumber";
import EditableSection from "../../../../../../../components/EditableSection";
import useDocumentDetails from "../../../../../../../hooks/useDocumentDetails";
import { useModalStore } from "../../../../../../../components/Modal/context/ModalStore";

export const InspectionTypeLabels = {
  [InspectionType.Preliminary]: "Preliminar",
  [InspectionType.Final]: "Final",
};

export type MappedInspection = Inspection & {
  claimsLabel: string;
};

interface InspectionProps {
  data: MappedInspection;
}

const InspectionFC: FC<InspectionProps> = ({ data: inspection }) => {
  const { refetch } = useDocumentDetails();
  const inspectionInfo = useMemo(() => {
    return [
      {
        label: "Tipo de Vistoria",
        value: InspectionTypeLabels[inspection.type] || "",
      },
      {
        label: "Data",
        value: formatISODate(inspection.date),
      },
      {
        label: "Agência Reguladora",
        value: inspection.regulatoryAgency,
      },
      {
        label: "Sinistros Associados",
        value: inspection.claimsLabel,
      },
    ];
  }, [inspection]);

  const inspectorInfo = useMemo(() => {
    return [
      {
        label: "Perito",
        value: inspection.inspector?.name,
      },
      {
        label: "Telefone",
        value: formatPhone(inspection.inspector?.mobilePhone || ""),
      },
    ];
  }, [inspection]);

  const { closeModal } = useModalStore();

  return (
    <EditableSection<{}, GetEditInspectionOnFormResponseQueryVariables>
      title={`${formatISODate(inspection.date)} - ${
        InspectionTypeLabels[inspection.type]
      }`}
      main
      editQuery={GetEditInspectionOnFormResponseDocument}
      editPayload={{
        objectId: inspection._id!,
        documentId: inspection.documentId!,
      }}
      objectId={inspection._id}
      onSubmit={() => {
        refetch(), closeModal();
      }}
    >
      <DetailsSectionColumns columns={[inspectionInfo, inspectorInfo]} />
    </EditableSection>
  );
};

export default InspectionFC;
